import { Pipe, PipeTransform } from '@angular/core';
import { ScanRequestType } from '@sona/shared-model-common';

const SCAN_REQUEST_TYPE_LABELS = {
    single: 'UTIL_COMMON.SCAN_REQUEST_TYPE.SINGLE',
    deep: 'UTIL_COMMON.SCAN_REQUEST_TYPE.DEEP'
};

@Pipe({
    name: 'scanRequestType'
})
export class ScanRequestTypePipe implements PipeTransform {

    transform(value?: ScanRequestType): string {
        return SCAN_REQUEST_TYPE_LABELS[value ?? 'single'];
    }
}
